// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"2304da2b","723":"f338ea81"}[chunkId] + ".chunk.css";
};